<template>
	<div>
		<vue-draggable-resizable
			class="element-position-lowerthird "
			:style="style"
			:class="className"
			v-if="status ==='preview'"
			:draggable="status ==='preview' && !item.is_locked && !content.isPosition"
			:resizable="status ==='preview' && !item.is_locked && !content.isPosition"
			:x="content.x"
			:y="content.y"
			:w="content.width"
			:h="content.height"
			@dragstop="onDragstop"
			@resizestop="onResizestop"
			@dragging="onDrag"
			@resizing="onResize"
			:preventActiveBehavior="true"
			:lock-aspect-ratio="isLockRatio"
			:parent="false">
			<div class="mb-6">
				<iframe
					scrolling="no"
					style="height:100%; border:0; pointer-events: none;"
					class="element-position"
					:class="className"
					width="100%"
					v-if="isTimer"
					:srcdoc="template()"
					:id="iframeId"
				/>
			</div>
		</vue-draggable-resizable>
		<div v-if="status ==='live'" class="element-position " :style="styleLive">
				<iframe
					:key="iframeKey"
					scrolling="no"
					style="width:100%; height:100%; border:0; pointer-events: none;"
					:class="className"
					v-if="isTimer"
					class="element-position"
					width="100%"
					height="100%"
					:id="iframeId"
				/>
		</div>
		<!-- Video Element -->
	</div>

	<!-- <div>
		<iframe
			scrolling="no"
			class="element-position"
			:srcdoc="template()"
			:class="className"
			:style="style"
			v-if="isTimer"
			:id="iframeId"
		/>
	</div> -->
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar } from '@/lib/helper';
import {
	timerTemplate,
} from '@/lib/statics';

export default {
	name: 'ElementTimer',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
			default: 'live',
		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	data() {
		return {
			localItem: null,
			iframeDocument: null,
			key: 0,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.key = this.key + 1;
				this.localItem = duplicateVar(data);
				const content = this.template();
				this.$nextTick(() => {
					const iframeDocument = document.getElementById(this.iframeId).contentDocument;
					document.getElementById(this.iframeId).contentWindow.location.reload();
					iframeDocument.open('text/html', 'replace');
					iframeDocument.write(content);
					iframeDocument.close();
				});
			}
		},
		timer_toggle_pause(data) {
			const { status, id } = data;
			if (this.localItem.id === JSON.parse(id)) {
				const iframe = document.getElementById(this.iframeId);
				if (iframe) iframe.contentWindow.postMessage({ action: 'togglePause', isPaused: JSON.parse(status) }, '*');
			}
		},
		// item_preview_update(item) {
		// 	if (this.status === 'preview') {
		// 		const isArrayItem = Array.isArray(item);
		// 		const iframe = document.getElementById(this.iframeId);
		// 		const currentIsPaused = this.content.isPaused;
		// 		const currentTimerSetting = this.content.timerSetting;
		// 		if (isArrayItem) {
		// 			const currentItem = item[0];
		// 			this.localItem = currentItem;
		// 		}
		// 		if (!isArrayItem) {
		// 			const currentItem = item;
		// 			this.localItem = currentItem;
		// 		}
		// 		const newContent = this.localItem.content && this.localItem.content !== ''
		// 			? JSON.parse(this.localItem.content) : {};
		// 		if (currentTimerSetting !== newContent.timerSetting) {
		// 			// // iframe.contentWindow.postMessage({ action: 'changeTemplate' }, '*');
		// 			// iframe.contentWindow.location.reload();
		// 			// const content = this.template();
		// 			// const iframeDocument = document.getElementById(this.iframeId) && document.getElementById(this.iframeId).contentDocument ? document.getElementById(this.iframeId).contentDocument : null;
		// 			// if (iframeDocument) iframeDocument.open('text/html', 'replace');
		// 			// if (iframeDocument) iframeDocument.write(content);
		// 			// if (iframeDocument) iframeDocument.close();
		// 		} else {
		// 			// eslint-disable-next-line no-lonely-if
		// 			if (currentIsPaused === newContent.isPaused) {
		// 				iframe.contentWindow.postMessage({ action: 'updatePreview' }, '*');
		// 				const content = this.template();
		// 				const iframeDocument = document.getElementById(this.iframeId).contentDocument;
		// 				iframeDocument.open('text/html', 'replace');
		// 				iframeDocument.write(content);
		// 				iframeDocument.close();
		// 			}
		// 		}
		// 	}
		// },
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	methods: {
		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {
		},
		onResize(x, y, width, height) {
			this.content.x = x;
			this.content.y = y;
			this.content.width = width;
			this.content.height = height;
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		getTemplate() {
			// get the active template
		},
		serializeCSS(css) {
			const src = css;
			const setupticker = src.replace(/__speed__/g, '40s');
			return setupticker;
		},
		serializeHTML(template) {
			const src = template;
			return src;
		},
		serializeJS(template) {
			const src = template;
			const bgColor = this.content.backgroundColor.length > 7 ? this.content.backgroundColor.slice(0, -2) : this.content.backgroundColor;
			const setupBackgroundColor = src.replace(/__backgroundColor__/g, `${bgColor}`);
			const setupColor = setupBackgroundColor.replace(/__color__/g, `${this.content.color}`);
			const setupTimer = setupColor.replace(/__time__/g, this.content.time);
			const setupMessage = setupTimer.replace(/__message__/g, this.content.message);
			const playingStatus = setupMessage.replace(/__STATUS__/g, this.status);
			const playingId = playingStatus.replace(/__APIURL__/g, process.env.VUE_APP_API_URL);
			const endpoint = playingId.replace(/__PLAYINGID__/g, this.localItem.id);
			const showBackground = endpoint.replace(/__SHOWBG__/g, this.content.showBackground ? '30' : '100');
			const fontIndex = showBackground.replace(/__fontidx__/g, this.content.fontStyle ? this.content.fontStyle : 0);
			const completeItem = fontIndex.replace(/__ONCOMPLETEITEM__/g, this.content.onCompleteItem ? this.content.onCompleteItem : false);
			const isPaused = completeItem.replace(/__ISPAUSED__/g, this.content.isPaused ? this.content.isPaused : false);
			const timerFormat = isPaused.replace(/__TIMERFORMAT__/g, this.content.timerFormat ? this.content.timerFormat : 1);
			return timerFormat;
		},
		template() {
			let setupTemplate = '';
			if (this.content) {
				const selectedTemplate = timerTemplate.find(({ id }) => id === this.content.timerSetting);
				const template = selectedTemplate && selectedTemplate.content ? JSON.parse(selectedTemplate.content) : null;

				if (template) {
					const finalCss = this.serializeCSS(template.style);
					const finalHTML = this.serializeHTML(template.content);
					const finalJs = this.serializeJS(template.script);
					setupTemplate = `
									<html>
									<head>
									<style>${finalCss}</style>
									<script src="https://grafias-medias.s3.eu-central-1.amazonaws.com/js/jquery-3.5.1.min.js"> <\/script>
									</head>
									<body>
										${finalHTML}
									</body>
									<script>${finalJs}<\/script>
									</html>
					`;
					// iframe.srcdoc = setupTemplate;
					return setupTemplate;
				}
			}
			return '';
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	beforeDestroy() {
		if (this.status === 'live') {
			if (this.content && this.content.onCompleteItem) {
				this.onCompletePlay(this.content.onCompleteItem);
			}
		}
	},
	mounted() {
		const content = this.template();
		this.$nextTick(() => {
			const iframeDocument = document.getElementById(this.iframeId).contentDocument;
			iframeDocument.open('text/html', 'replace');
			iframeDocument.write(content);
			iframeDocument.close();
		});
	},
	computed: {
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		widthElement() {
			return this.content && this.content.width ? this.content.width : 0;
		},
		heightElement() {
			return this.content && this.content.height ? this.content.height : 0;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			// if (content.width) style.width = `${content.width}px`;
			// if (content.height) style.height = `${content.height}px`;
			// if (content.y) style.top = `${content.y}px`;
			// if (content.x) style.left = `${content.x}px`;
			return style;
		},
		isTimer() {
			return this.localItem.type === 'timer';
		},
		zoomUrl() {
			return this.localItem;
		},
		iframeId() {
			return this.status === 'live' ? `timer-live-${this.localItem.slug}` : `timer-preview-${this.localItem.slug}`;
		},
		iframeKey() {
			return this.status === 'live' ? `timer-live-${this.localItem.slug}-${this.key}` : `timer-preview-${this.localItem.slug}-${this.key}`;
		},
	},

};
</script>
